export interface CancellationModel {
  status: CancellationStatus;
  error?: string;
}

export type CancellationStatus = 'INIT' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED' | 'REJECTED';

export type CancellationState = Readonly<Record<string, CancellationModel>>;

export const initialCancellationState = (): CancellationState => ({});
